import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-yellow-400 via-yellow-300 to-blue-500 min-h-screen flex items-center">
      <div className="absolute inset-0 bg-black opacity-10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start mb-4">
              <div className="bg-blue-600 text-white px-6 py-2 rounded-lg font-bold text-lg mr-4">
                Freie Demokraten FDP
              </div>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-blue-900 mb-6">
              Kai Alexander Bewig
            </h1>
            <div className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full inline-block mb-8">
              <span className="text-3xl font-bold">Platz 3</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-blue-800 mb-4">
              Für Lauingen.
            </h2>
            <h2 className="text-3xl lg:text-4xl font-bold text-blue-800 mb-8">
              Für unsere Zukunft.
            </h2>
            <p className="text-xl text-blue-700 mb-8 max-w-2xl">
              Stadtrat Lauingen (Donau) - 49 Jahre - Webdesigner
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link 
                to="/kontakt"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors"
              >
                Kontakt aufnehmen
              </Link>
              <a 
                href="#about"
                className="bg-white hover:bg-gray-50 text-blue-600 px-8 py-4 rounded-lg font-bold text-lg border-2 border-blue-600 transition-colors"
              >
                Mehr erfahren
              </a>
            </div>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              {/* Wahlkreuz Symbol anstelle des Fotos */}
              <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-full shadow-2xl border-8 border-white bg-white flex items-center justify-center overflow-hidden">
                <div className="w-full h-full bg-blue-50 flex items-center justify-center relative">
                  {/* Ein stilisierter Kreis für das Wahlkreuz */}
                  <div className="absolute inset-4 border-4 border-blue-200 rounded-full"></div>
                  <SafeIcon 
                    icon={FiX} 
                    className="text-blue-600 text-[12rem] lg:text-[16rem] relative z-10" 
                  />
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-yellow-400 text-blue-900 px-6 py-3 rounded-full font-bold text-lg shadow-lg">
                Deine Wahl. 8.3.26
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;